<template>
  <v-carousel v-model="model" show-arrows-on-hover hide-delimiters hide-delimiter-background :dark="false" light height="100%">
    <div>Carousel of Collaterals to pay</div>
    <v-carousel-item
      v-for="(collateral,index) in collaterals" :key="collateral._id"
    >
      <v-sheet
        color="white"
      >
        <div style="margin: 10px;text-align: center">
          Pagament {{ index+1 }} de {{ collaterals.length }}
        </div>
        <PaymentComponent :id-form="'Form'+index" :id-card="'Card'+index" :id-btn="'Btn'+index" :amount="collateral.amount" :user="collateral.receiver" :factoring="factoring" :collateral="collateral._id" @success="onSuccess(index)" @cancel="onCancel" />
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";
import Constants from "../../constants";
import PaymentComponent from "../components/Payment";

export default {
    name: "CarouselPayments",
    components: { PaymentComponent},
    props: {
        factoring: {
            type: Object,
            require: false
        },
        collaterals: {
            type: Array,
            required: true
        },
    },
    data () {
        return {
            model: 0,
        };
    },
    created () {
    },
    methods: {
        onSuccess (index) {
            console.log("SUCCESS "+ index);
            ApiRepository.payCollateralStripe(this.factoring._id, index).then((res)=>{
                console.log("SUCCESS")
            }).catch((e)=>{});
        },
        onCancel () {
            console.log("cancel");
        },

    }
};
</script>

<style scoped>

</style>
